import styles from '../product-comparison-grid.module.scss';
import cx from 'classnames';

interface ProductCardBottomIconsProps {
  children: React.ReactNode;
}

const ProductCardBottomIcons = ({ children }: ProductCardBottomIconsProps) => (
  <div
    className={cx(
      'd-flex justify- gap-2',
      styles['product-comparison__card-bottom-icons']
    )}
  >
    {children}
  </div>
);

export default ProductCardBottomIcons;
